import { render, staticRenderFns } from "./CompanyPrivacyOfficerForm.vue?vue&type=template&id=2ec2ee00&"
import script from "./CompanyPrivacyOfficerForm.vue?vue&type=script&lang=js&"
export * from "./CompanyPrivacyOfficerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CompanyPrivacyOfficerForm.vue"
export default component.exports